var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoData = function SvgNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD3D8",
    d: "m20.15 40.91 4.53-18.12A4.99 4.99 0 0 1 29.53 19h20.94c2.3 0 4.3 1.56 4.85 3.79l4.53 18.12c.1.4.15.8.15 1.21V49c0 2.76-2.24 5-5 5H25c-2.76 0-5-2.24-5-5v-6.88c0-.41.05-.82.15-1.21M25 52.75h30c2.07 0 3.75-1.68 3.75-3.75v-6.88c0-.21-.02-.41-.05-.62h-7.92c-.24 0-.45.13-.56.34l-1.81 3.62c-.32.64-.97 1.04-1.68 1.04H33.28c-.71 0-1.36-.41-1.68-1.04l-1.81-3.62a.64.64 0 0 0-.56-.34H21.3c-.04.2-.05.41-.05.62V49c0 2.07 1.68 3.75 3.75 3.75m29.11-29.66a3.754 3.754 0 0 0-3.64-2.84H29.53c-1.73 0-3.23 1.17-3.64 2.84L21.6 40.25h7.62c.71 0 1.36.41 1.68 1.04l1.81 3.62c.11.21.33.34.56.34h13.45c.24 0 .45-.13.56-.34l1.81-3.62c.32-.64.97-1.04 1.68-1.04h7.62L54.1 23.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FA",
    d: "M54.11 23.09a3.754 3.754 0 0 0-3.64-2.84H29.53c-1.73 0-3.23 1.17-3.64 2.84L21.6 40.25h7.62c.71 0 1.36.41 1.68 1.04l1.81 3.62c.11.21.33.34.56.34h13.45c.24 0 .45-.13.56-.34l1.81-3.62c.32-.64.97-1.04 1.68-1.04h7.62L54.1 23.09z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#CDD3D8",
    strokeWidth: 1.2,
    clipPath: "url(#no-data_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M11.5 30.5a2.9 2.9 0 1 0 0-5.8 2.9 2.9 0 0 0 0 5.8ZM27.72 3.66l-4.23 2.11c-.37.18-.4.7-.06.92l3.95 2.61c.34.23.8 0 .83-.41l.29-4.72c.02-.41-.4-.69-.77-.51z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m67.41 15.44-4.85 3.19M66.57 19.46l-3.18-4.85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "no-data_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 3h60.01v28.1H8z"
  })))));
};
export default SvgNoData;